/**
 * File Upload Preview and Management
 * Adds preview and removal functionality for multiple file uploads across all forms
 */

(function() {
  'use strict';

  // Initialize file preview for all file inputs with multiple attribute
  function initFileUploadPreviews() {
    const fileInputs = document.querySelectorAll('input[type="file"][multiple]');
    
    fileInputs.forEach(fileInput => {
      // Bug 3 fix: skip inputs already initialised to avoid duplicate change listeners
      if (fileInput.dataset.uploadInitialized) return;
      fileInput.dataset.uploadInitialized = 'true';

      // Create preview container if it doesn't exist
      let previewContainer = fileInput.parentElement.querySelector('.file-preview-container');
      
      if (!previewContainer) {
        previewContainer = document.createElement('div');
        previewContainer.className = 'file-preview-container';
        fileInput.parentElement.insertBefore(previewContainer, fileInput.nextSibling);
      }

      // Store accumulated files for this input
      let accumulatedFiles = new DataTransfer();

      // Bug 1 fix: clear preview and DataTransfer when the parent form is reset
      const parentForm = fileInput.closest('form');
      if (parentForm) {
        parentForm.addEventListener('reset', function() {
          accumulatedFiles = new DataTransfer();
          previewContainer.innerHTML = '';
        });
      }

      // Handle file selection
      fileInput.addEventListener('change', function(e) {
        const newFiles = Array.from(e.target.files);
        
        // Add new files to accumulated files (avoiding duplicates by name)
        const existingFileNames = Array.from(accumulatedFiles.files).map(f => f.name);
        
        newFiles.forEach(file => {
          if (!existingFileNames.includes(file.name)) {
            accumulatedFiles.items.add(file);
          }
        });
        
        // Update the file input with accumulated files
        fileInput.files = accumulatedFiles.files;
        
        // Render preview
        renderFilePreview(previewContainer, accumulatedFiles, fileInput);
      });

      // Function to render file preview
      function renderFilePreview(container, dataTransfer, input) {
        container.innerHTML = '';
        
        if (dataTransfer.files.length === 0) {
          return;
        }

        const fileList = document.createElement('div');
        fileList.className = 'file-preview-list';

        Array.from(dataTransfer.files).forEach((file, index) => {
          const fileItem = createFilePreviewItem(file, index, dataTransfer, input, container);
          fileList.appendChild(fileItem);
        });

        container.appendChild(fileList);
      }

      // Function to create individual file preview item
      function createFilePreviewItem(file, index, dataTransfer, input, container) {
        const fileItem = document.createElement('div');
        fileItem.className = 'file-preview-item';
        
        // File size in readable format
        const fileSize = formatFileSize(file.size);
        
        fileItem.innerHTML = `
          <div class="file-preview-info">
            <div class="file-preview-name" title="${file.name}">${truncateFileName(file.name, 40)}</div>
            <div class="file-preview-size">${fileSize}</div>
          </div>
          <button type="button" class="file-preview-remove" data-index="${index}" aria-label="Remove ${file.name}">
            Remove
          </button>
        `;

        // Add remove functionality
        const removeBtn = fileItem.querySelector('.file-preview-remove');
        removeBtn.addEventListener('click', function() {
          removeFile(index, dataTransfer, input, container);
        });

        return fileItem;
      }

      // Function to remove a file
      function removeFile(index, dataTransfer, input, container) {
        const newDataTransfer = new DataTransfer();
        
        // Copy all files except the one to remove
        Array.from(dataTransfer.files).forEach((file, i) => {
          if (i !== index) {
            newDataTransfer.items.add(file);
          }
        });

        // Update the accumulated files reference
        accumulatedFiles = newDataTransfer;
        
        // Update the file input
        input.files = newDataTransfer.files;
        
        // Re-render preview
        renderFilePreview(container, newDataTransfer, input);
      }
    });
  }

  // Helper function to format file size
  function formatFileSize(bytes) {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
  }

  // Helper function to truncate long file names
  function truncateFileName(name, maxLength) {
    if (name.length <= maxLength) return name;
    const extension = name.split('.').pop();
    const nameWithoutExt = name.substring(0, name.lastIndexOf('.'));
    const truncated = nameWithoutExt.substring(0, maxLength - extension.length - 4) + '...';
    return truncated + '.' + extension;
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFileUploadPreviews);
  } else {
    initFileUploadPreviews();
  }

  // Re-initialize if new content is added dynamically (for modals)
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        initFileUploadPreviews();
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();
